/*
 * @Author: 张家林
 * @LastEditors: 张家林
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about/:productName',
    name: 'about',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Detail.vue')
  },
  {
    path: '/InstallationProcess',
    name: 'InstallationProcess',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InstallationProcess.vue')
  },
  {
    path: '/HaveOrder',
    name: 'HaveOrder',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/HaveOrder.vue')
  },
  {
    path: '/NoOrder',
    name: 'NoOrder',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/NoOrder.vue')
  },
  {
    path: '/ZTHaveOrder',
    name: 'ZTHaveOrder',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ZTHaveOrder.vue')
  },
  {
    path: '/jitong',
    name: 'jitong',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Jitong.vue')
  },
  {
    path: '/zhaoshang',
    name: 'zhaoshang',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/Zhaoshang.vue')
  },
  {
    path: '/gantong',
    name: 'gantong',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Gantong.vue')
  },


]

const router = new VueRouter({
  routes
})

export default router
